import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientSignatureRequestModel } from 'src/app/core/models/members/client/client-signature-request.model';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-signature-request-modal',
  templateUrl: './signature-request-modal.component.html',
  styleUrls: ['./signature-request-modal.component.scss']
})
export class SignatureRequestModalComponent {
  constructor(
    private url: ActivatedRoute,
    private modalRef: NgbActiveModal,
    private myFileApiService: MyfileApiService,
    private toasterNotificationService: ToasterNotificationService, 
    private authService: AuthMyfileService,
    ) { }
  @Input() public model: ClientSignatureRequestModel = new ClientSignatureRequestModel();;  
  @Input() public clientName?: String;
  
  emailSent:boolean = false;

  modalEdited:boolean = false; 
  submitted: boolean = false; 
  emailPattern = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

  sendEmail(){
    this.submitted = true;
    if(this.validation()){
      this.modalEdited = false; 
      this.model.email = this.model?.email?.trim().toLowerCase(); 
      if(this.model.showPdfPreview){
        this.model.signUrl = window.location.protocol+"//"+window.location.host+'/auth/pdfviewersignature'
      }else{
        this.model.signUrl = window.location.protocol+"//"+window.location.host+'/auth/signaturerequest'
      }
      this.myFileApiService.sendEmailSignatureRequest(this.model).subscribe(result=>{
        if(result){
          this.emailSent = true;
          this.toasterNotificationService.showSuccess($localize `:@@:Signature request sent successfully`, $localize `:@@Toast_Success_GeneralTitle:Success`);
          this.modalRef.close(); 
        }
      })
    } 
  }
  close(){
    if(this.modalEdited){
      this.confirmExit();
    }else{
      this.modalRef.close();
    }
  }
  confirmExit() {
    Swal.fire({   
      color:'var(--vz-body-color)',
      background: 'var(--vz-body-bg)',
      title: $localize `:@@SWAL_UnsavedChanges:You have unsaved changes!`,
      text: $localize `:@@:Are you sure you want to abandon this invite?` ,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: $localize `:@@SWAL_Yes_Discard:Yes, discard changes`,
      cancelButtonText: $localize `:@@:No, let me send it`
    }).then(result => {
      if (result && result.isConfirmed) {
        this.modalRef.close();
      }
    });
  }
  validation(){
    if(
         this.model.email != undefined
      && this.model.email != ""
      ){
       return true;   
      }
    this.toasterNotificationService.showWarning($localize `:@@Toast_Error_FeildsRequiredText:Something went wrong. Please make sure all fields are filled in correctly.`, $localize `:@@Toast_Warn_Title_MissingInformation:Error`); 
    return false;     
  }
}
